import {
  SET_WAIVER_FORMS,
  SET_WAIVER_FORM_FIELD
} from 'actions/account/forms/waiverForms/actionTypes'

import setWaiverForms from './setWaiverForms'
import setWaiverFormField from './setWaiverFormField'

const reducer = (state = {}, action) => {
  switch (action.type) {
    case SET_WAIVER_FORM_FIELD:
      return setWaiverFormField(state, action)
    case SET_WAIVER_FORMS:
      return setWaiverForms(state, action)
    default:
      return state
  }
}

export default reducer
